import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useDeleteTaxonomyTranslation } from '@global/hooks/mutations/taxonomy-translations'
import { useInvalidateTaxonomyTranslations } from '@global/hooks/queries/taxonomy-translations'
import * as SnackbarActions from '@global/snackbar/snackbar.actions'
import { TaxonomyTranslation } from '@taxonomy-translation/types'
import { ROUTES } from 'routes'
import { Button } from './button'
import { Modal } from './modal'
import { t } from '@lingui/core/macro'

interface Props {
  translation: TaxonomyTranslation
  onClose: () => void
}

export const DeleteModal = ({ onClose, translation }: Props) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const invalidateTaxonomyTranslations = useInvalidateTaxonomyTranslations()

  const deleteMutation = useDeleteTaxonomyTranslation(translation.uuid, {
    onSuccess: () => {
      onClose()
      void invalidateTaxonomyTranslations()
      history.replace(ROUTES.TAXONOMY_TRANSLATION)

      dispatch(
        SnackbarActions.showSnackbar({
          message: 'Translation successfully deleted',
          type: 'SUCCESS',
          duration: 3000,
        }),
      )
    },
    onError: () => {
      SnackbarActions.showSnackbar({
        message: 'Something went wrong',
        type: 'ERROR',
        duration: 6000,
      })
    },
  })

  const handleDelete = () => {
    deleteMutation.mutate()
  }

  return (
    <Modal onClose={onClose}>
      <div>
        <h2 className="font-sans font-bold mb-7 text-xl">{t`Are you sure you want to delete?`}</h2>
        <p className="text-sm mb-14">
          {t`Are you sure you want to delete “`}
          {translation.name}
          ”? You can’t undo this action.
        </p>
        <div className="flex justify-between mt-4">
          <Button onClick={onClose} variant="outline" className="bg-[#F6F8FA]">
            {t`Close`}
          </Button>
          <Button variant="warn" onClick={handleDelete} disabled={deleteMutation.isPending}>
            {t`Delete`}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
